import { z } from 'zod/v4';

export const PlatformFeatureDetailSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.number(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  updatedByUserId: z.string().nullable(),
});

export type PlatformFeatureDetail = z.infer<typeof PlatformFeatureDetailSchema>;

export const PlatformFeatureSchema = PlatformFeatureDetailSchema.extend({
  enabledCompaniesCount: z.number(),
});

export type PlatformFeature = z.infer<typeof PlatformFeatureSchema>;

export const EnabledPlatformFeatureSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
});

export type EnabledPlatformFeature = z.infer<
  typeof EnabledPlatformFeatureSchema
>;
